import i18n from '@/locales/i18n'

const columns = [
    {
        title: i18n.t('billsReceivable.clientName'),
        dataIndex: "customerName",
        width: "250px",
        align: "center",
        scopedSlots: { customRender: 'customerName' }
    },
    {
        title: i18n.t('billsReceivable.accountNumber'),
        dataIndex: "number",
        width: "120px",
        align: "center",
        scopedSlots: { customRender: 'number' }
    },
    {
        title: i18n.t('billsReceivable.billDate'),
        dataIndex: "fromDate",
        width: "200px",
        align: "center",
        scopedSlots: { customRender: 'fromDate' }
    },
    {
        title: i18n.t('billsReceivable.feesReceivable'),
        dataIndex: "receivableAmount",
        width: "150px",
        align: "center",
        scopedSlots: { customRender: 'receivableAmount' }
    },
    {
        title: i18n.t('billsReceivable.paymentTime'),
        dataIndex: "paymentTime",
        width: "120px",
        align: "center",
        scopedSlots: { customRender: 'paymentTime' }
    },
    {
        title: i18n.t('billsReceivable.invoicingTime'),
        dataIndex: "billingTime",
        width: "120px",
        align: "center",
        scopedSlots: { customRender: 'billingTime' }
    },

    {
        title: i18n.t('billsReceivable.invoiceNumber'),
        dataIndex: "invoiceNumber",
        width: "250px",
        align: "center",
        scopedSlots: { customRender: 'invoiceNumber' },
        ellipsis: true
    },
    {
        title: i18n.t('billsReceivable.invoiceRemarks'),
        dataIndex: "invoiceRemark",
        width: "250px",
        align: "center",
        scopedSlots: { customRender: 'invoiceRemark' },
        ellipsis: true
    }
];


const changeCode = (code, arr) => {
    let value;
    arr.forEach(item => {
        if (item.value === code) {
            value = item.label;
        }
    });
    return value;
}
export {
    columns, changeCode
}